import { post } from  "helpers/api_helper/Authentication/authenticationApiHelper"
import * as url from "helpers/url_helper/url_helper"

const getLoggedInUser = () => {
    const user = localStorage.getItem("user")
    if (user) return JSON.parse(user)
    return null
  }
  
  //is user is logged in
  const isUserAuthenticated = () => {
    return getLoggedInUser() !== null
  }
  
  // Login Method
  const postLogin = data => post(url.POST_LOGIN, data)
  const postVerify2fSecret = data => post(url.POST_2F_VERIFY, data)
  const postVerify2fLogin = data => post(url.POST_2F_LOGIN, data)
  const postForgetPwd = data => post(url.POST_PWD_FORGET, data)
  const postFakeProfile = data => post(url.POST_PWD_FORGET, data)
  const postsendVerificationCode = data => post(url.POST_SEND_VERIFICATION_CODE, data)
  
  export {
    getLoggedInUser,
    isUserAuthenticated,
    postFakeProfile,
    postForgetPwd,
    postLogin,
    postVerify2fSecret,
    postVerify2fLogin,
    postsendVerificationCode
  }